import React, { useState, useEffect, useContext, useRef } from 'react'
import ReactPaginate from 'react-paginate'
import TableSkeleton from '../../../../components/Skeleton/TableSkeleton'
import { ProductContext } from '../../../../store'
import { PostData } from '../../../../services/FetchData'
import { Table } from 'reactstrap'
import { useNavigate } from 'react-router-dom'

const FiltersList = () => {
	const [searchTerm, setSearchTerm] = useState(''),
		[debouncedSearch, setDebouncedSearch]	= useState(''),
		[limit, setLimit] = useState(15),
		[selectedFilters, setSelectedFilters] = useState([]),
		[filters, setFilters] = useState([]),
		[pageLoader, setPageLoader] = useState(true),
		[currentPage, setCurrentPage] = useState(0),
		[totalPages, setTotalPages] = useState(0),
		[totalRecords, setTotalRecords] = useState(0),
		{ currentWebsiteId } = useContext(ProductContext),
		debouncedTimeout	= useRef(null),
		navigate	= useNavigate()

	useEffect(() => {
		if (currentWebsiteId) {
			fetchFilters()
		}
	}, [currentWebsiteId, currentPage, limit, debouncedSearch])

	useEffect(() => {
		if (debouncedTimeout.current) {
			clearTimeout(debouncedTimeout.current);
		}
		debouncedTimeout.current = setTimeout(() => {
			setDebouncedSearch(searchTerm);
		}, 500);

		// Clean up the timeout on component unmount or when searchTerm changes
		return () => {
			clearTimeout(debouncedTimeout.current);
		};
	}, [searchTerm]);

	const fetchFilters = () => {
		setPageLoader(true)
		const page = currentPage + 1

		PostData("ms1", "api/v1/filters/getAllFilters", {websiteId: currentWebsiteId, searchKey: debouncedSearch, page, limit}).then(result => {
			if (result !== "Invalid" && result !== "undefined") {
				if (result.status === "success") {
					setFilters(result.data.filters || [])
					setTotalRecords(result.data.pagination?.totalRecords || 0)
					setTotalPages(Math.ceil((result.data.pagination?.totalRecords || 0) / limit))
				} else {
					setFilters([])
				}
			} else {
				setFilters([])
			}
			setPageLoader(false)
		}).catch(error => {
			setFilters([])
			setPageLoader(false)
		})
	}

	const handleFilterSelect = (filterId) => {
		setSelectedFilters((prev) =>
			prev.includes(filterId)
				? prev.filter((id) => id !== filterId)
				: [...prev, filterId]
		);
	};

	const handleSelectAll = () => {
		if (selectedFilters.length === filters.length) {
			setSelectedFilters([]);
		} else {
			setSelectedFilters(filters.map((filter) => filter.id));
		}
	};

	// Handle pagination
	const handlePageClick = (event) => {
		setCurrentPage(event.selected)
	}

	// Handle display count change
	const handleLimit = (newCount) => {
		setLimit(newCount)
		setCurrentPage(0)
	}

	const handleEditFilter = (filter) => {
		return navigate(`/search/filter/${filter.filterId}`);
	}

	const handleAddFilter = () => {	
		navigate("/search/filter/add");
	}

	const handleBackFromAddFilter = () => {
		// if (onViewChange) {
		// 	onViewChange("list");
		// }
	};

	const handleSaveAddFilter = (filterData) => {
		// Here you would typically save the filter to your backend
		// For now, we'll just close the add filter form
		// if (onViewChange) {
		// 	onViewChange("list");
		// }
	};

	// Show AddFilter component if showAddFilter is true
	// if (showAddFilter) {
	// 	return (
	// 		<AddFilter
	// 			onBack={handleBackFromAddFilter}
	// 			onSave={handleSaveAddFilter}
	// 		/>
	// 	);
	// }

	return (
		<div className="filterListContainer">
			<div className="filterListControls">
				<div className="filterListSearch">
					<input
						type="text"
						placeholder="Search filters"
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						className="filterListSearchInput"
					/>
				</div>
				<div className="filterListDisplayOptions">
					<label>Display</label>
					<select
						value={limit}
						onChange={(e) => handleLimit(parseInt(e.target.value))}
						className="filterListDisplaySelect"
					>
						<option value="5">5</option>
						<option value="10">10</option>
						<option value="15">15</option>
						<option value="20">20</option>
						<option value="25">25</option>
						<option value="30">30</option>
					</select>
				</div>

				<button className="filterListAddButton" onClick={handleAddFilter}>
					<span className="filterListAddIcon">+</span>
					Add filter
				</button>
			</div>
			<div className="filterListTable">
				<Table hover striped>
					<thead>
						<tr>
							<th>Title</th>
							<th>Type</th>
							<th>Appearance</th>
							<th>Actions</th>
						</tr>
					</thead>
					{!pageLoader &&
						<tbody>
							{filters.map((filter) => {
								return (
									<tr>
										<td>{filter.title}</td>
										<td>{filter.type}</td>
										<td>{filter.appearance}</td>
										<td>
										{( filter.attribute !== 'effective_price' && filter.attribute !== "reviews" ) && (
											<button
												className={`filterListEditButton visible`}
												onClick={() => handleEditFilter(filter)}
												title="Edit filter"
											>
												<i className="fa-solid fa-pencil"></i>
											</button>
										)}
										</td>
									</tr>
								)
							})}
						</tbody>
					
					}	
				</Table>
				{pageLoader &&
					<TableSkeleton />
				}
			</div>
			<div className="filterListPagination">
				{!pageLoader &&
					<div className="paginationInfo">
						Showing {currentPage * limit + 1} to {Math.min((currentPage + 1) * limit, totalRecords)} of {totalRecords} entries
					</div>
				}
				{totalPages > 1 && (
					<ReactPaginate
						breakLabel="..."
						nextLabel=">"
						previousLabel="<"
						onPageChange={handlePageClick}
						pageRangeDisplayed={5}
						pageCount={totalPages}
						renderOnZeroPageCount={null}
						containerClassName="pagination"
						pageClassName="page-item"
						pageLinkClassName="page-link"
						previousClassName="page-item"
						previousLinkClassName="page-link"
						nextClassName="page-item"
						nextLinkClassName="page-link"
						breakClassName="page-item"
						breakLinkClassName="page-link"
						activeClassName="active"
						forcePage={currentPage}
					/>
				)}
			</div>
		</div>
	);
}

export default FiltersList;